import { Injectable, inject } from '@angular/core';
import { User } from 'firebase/auth';
import { Observable, tap } from 'rxjs';
import { OpenAuthClient, injectOpenAuth } from '@open/ngx-firebase/auth';
import { ConfirmationResponse } from '../../assets/responses/Confirmation.response';
import { LoginForUserWithPinRequest } from '../../assets/requests/auth/LoginForUserWithPin.request';
import { UserModel } from '../../assets/models/user/User.model';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly #userService: UsersService = inject(UsersService);
  readonly #client: OpenAuthClient<UserModel> = injectOpenAuth<UserModel>({
    appKey: 'mobileCashier',
    markActivatedOnPasswordUpdate: true,
    markActivatedOnPinLogin: false,
  });

  readonly user$: Observable<User | null> = this.#client.user$;
  readonly isAuthorized$: Observable<boolean> = this.#client.hasRole$('BUSINESS_CASHIER');

  logout(): Promise<void> {
    return this.#client.logout();
  }

  logout$(): Observable<void> {
    return this.#client.logout$();
  }

  login$(email: string, password: string): Observable<UserModel> {
    return this.#client.login$(email, password);
  }

  loginForUserWithPin$(request: LoginForUserWithPinRequest): Observable<UserModel> {
    return this.#client.loginWithPin$(request).pipe(
      tap((user: UserModel) => this.#userService.setUserFromDb$(user)),
    );
  }

  checkIsActivatedUser$(email: string): Observable<{ isActivated: boolean }> {
    return this.#client.checkIsActivatedUser$(email);
  }

  createPinForUser$(email: string): Observable<ConfirmationResponse> {
    return this.#client.createPin$(email);
  }

  updateUserPassword$(password: string): Observable<UserModel> {
    return this.#client.updatePassword$(password);
  }

  acceptedCgu$(): Observable<void> {
    return this.#client.acceptCgu$();
  }
}
